// theme constant
export const gridSpacing = 3;
export const drawerWidth = 230;
export const appDrawerWidth = 320;
export const borderRadius = 3;

export const bagSaleTypes = [
    'Yellow (30x36)',
    'Yellow (26x28)',
    'Yellow (21x26)',
    'Yellow (19x20)',
    'Red (30x36)',
    'Red (26x28)',
    'Red (21x26)',
    'Red (19x20)',
    'Black (30x36)',
    'Black (21x26)'
];
export const Statuses = [
    { title: 'Active', id: 1 },
    { title: 'Inactive', id: 2 }
];
export const paymentModes = [
    { id: 0, title: 'Online' },
    { id: 1, title: 'Cheque' },
    { id: 2, title: 'Cash' }
];

export const segregationLevels = [
    { id: 1, title: 'Basic Segregation' },
    { id: 2, title: 'Primary Segregation' },
    { id: 3, title: 'Tertiary Segregation' }
];
export const paymentTypes = [
    { id: 1, title: 'Paid' },
    { id: 2, title: 'Received' }
];
export const GSTRates = [
    { title: '@0%', id: 0 },
    { title: '@5%', id: 5 },
    { title: '@12%', id: 12 },
    { title: '@18%', id: 18 },
    { title: '@28%', id: 28 }
];
